import * as yup from "yup";

export const editValidationSchema = yup.object().shape({
  code: yup.string().optional(),
  name: yup
    .string()
    .max(200, "Tên nhóm mặt hàng không được vượt quá 200 ký tự")
    .required("Vui lòng nhập tên nhóm mặt hàng"),
});
